const clamp = (value, min, max) =>
  Math.max(min, Math.min(max, value));

export default clamp;